import React from "react";
import { Table } from "antd";

export const NarrowTable = () => {
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      align: "right",
      render: (value) => `$${value.toFixed(2)}`,
    },
  ];

  const data = [
    {
      key: "1",
      title: "Item 1",
      value: 4524.14,
    },
    {
      key: "2",
      title: "Item 2",
      value: 156.24,
    },
    {
      key: "3",
      title: "Item 3",
      value: 912.94,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      className="custom-table"
    />
  );
};
const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return "$ 0.00";
  }
  const number = typeof value === "number" ? value : parseFloat(value);
  return `$ ${Math.abs(number).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const formatPercent = (value) => {
  if (value === null || value === undefined || value === "") {
    return "0 %";
  }
  return `${Math.abs(value)}%`;
};
const getColor = (val) => (parseFloat(val) < 0 ? "red" : "inherit");
export const QuarterTargetTable = ({ data }) => {
  const descriptionLabels = [
    { key: "totalRx", label: "Total RX Spend" },
    { key: "genericRx", label: "Generic RX Spend" },
    { key: "brandRx", label: "Brand RX Spend" },
    { key: "gcrPct", label: "GCR %" },
    { key: "cogsPct", label: "COGS %" },
  ];

  const dataSource = descriptionLabels.map((item, index) => {
    const isPercent = item.key === "gcrPct" || item.key == "cogsPct";
    return {
      key: index,
      label: item.label,
      current: isPercent
        ? formatPercent(data?.current?.[item.key])
        : formatCurrency(data?.current?.[item.key]),
      estimate: isPercent
        
          ? formatPercent(data?.estimate?.[item.key])
          : formatCurrency(data?.estimate?.[item.key]),
      change: (
        <span style={{ color: getColor(data?.change?.[item.key]) }}>
          {isPercent
            ? formatPercent(data?.change?.[item.key])
            : // ? `${Math.abs(parseFloat(data?.change?.[item.key] || 0).toFixed(2))}%`
            
           formatCurrency(data?.change?.[item.key])}
        </span>
      ),
    };
  });
  const columns = [
    {
      title: "Description",
      dataIndex: "label",
      key: "label",
      align: "left",
    },
    {
      title: "Current",
      dataIndex: "current",
      key: "current",
      align: "left",
    },
    {
      title: "Estimate",
      dataIndex: "estimate",
      key: "estimate",
      align: "left",
    },
    {
      title: "Change",
      dataIndex: "change",
      key: "change",
      align: "left",
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      // loading={isloading}
      columns={columns}
      size="small"
      bordered
      pagination={false}
      rowKey={(record, idx) => idx}
      className="border-table custom-table user-tbl"
      // scroll={{ x: "max-content", y: "400px" }}
      scroll={{ x: 500, y: 250 }}
      // scroll={{ x: 500, y: 250 }}
      style={{ width: "100%" }}
    />
  );
};

export const SGCRTargetTable = ({ data }) => {
  const descriptionLabels = [
    { key: "totalRx", label: "Total RX Spend" },
    { key: "genericRx", label: "Generic RX Spend" },
    { key: "brandRx", label: "Brand RX Spend" },
    { key: "rebateableBrand", label: "Rebateable Brand" },
    { key: "rebateableGeneric", label: "Rebateable Generic" },
    { key: "sgcrPct", label: " SGCR %" },
    { key: "rebateBrand", label: "Rebate Brand ($)" },
    { key: "rebateGeneric", label: "Rebate Generic ($)" },
    { key: "rebateTotal", label: "Rebate Total ($)" },
    { key: "rebatePercBrand", label: "Rebate Percentage Brand" },
    { key: "rebatePercGeneric", label: "Rebate Percentage Generic" },
  ];

  const dataSource = descriptionLabels.map((item, index) => {
    const isPercent =
      item.key === "sgcrPct" ||
      item.key === "rebatePercGeneric" ||
      item.key === "rebatePercBrand";
    return {
      key: index,
      label: item.label,
      current: isPercent
        ? formatPercent(data?.current?.[item.key])
        : item.key === "rebateBrand"
        ? formatCurrency(data?.current?.rebateDollars?.brand)
        : item.key === "rebateGeneric"
        ? formatCurrency(data?.current?.rebateDollars?.generic)
        : item.key === "rebateTotal"
        ? formatCurrency(data?.current?.rebateDollars?.total)
        : formatCurrency(data?.current?.[item.key]),
      estimate:
        item.key === "sgcrPct"
          ? formatPercent(data?.estimate?.sgcrPct)
          : item.key === "rebatePercBrand"
          ? formatPercent(data?.estimate?.rebatePercBrand)
          : item.key === "rebatePercGeneric"
          ? formatPercent(data?.estimate?.rebatePercGeneric)
          : isPercent
          ? formatPercent(data?.estimate?.[item.key])
          : item.key === "rebateBrand"
          ? formatCurrency(data?.estimate?.rebateDollars?.brand)
          : item.key === "rebateGeneric"
          ? formatCurrency(data?.estimate?.rebateDollars?.generic)
          : item.key === "rebateTotal"
          ? formatCurrency(data?.estimate?.rebateDollars?.total)
          : formatCurrency(data?.estimate?.[item.key]),
      change: (
        <span style={{ color: getColor(data?.change?.[item.key]) }}>
          {isPercent
            ? formatPercent(data?.change?.[item.key])
            : // ? `${Math.abs(parseFloat(data?.change?.[item.key] || 0).toFixed(2))}%`
            item.key === "rebateBrand"
            ? formatCurrency(data?.change?.rebateDollars?.brand)
            : item.key === "rebateGeneric"
            ? formatCurrency(data?.change?.rebateDollars?.generic)
            : item.key === "rebateTotal"
            ? formatCurrency(data?.change?.rebateDollars?.total)
            : formatCurrency(data?.change?.[item.key])}
        </span>
      ),
    };
  });
  const columns = [
    {
      title: "Description",
      dataIndex: "label",
      key: "label",
      align: "left",
    },
    {
      title: "Current",
      dataIndex: "current",
      key: "current",
      align: "right",
    },
    {
      title: "Estimate",
      dataIndex: "estimate",
      key: "estimate",
      align: "right",
    },
    {
      title: "Change",
      dataIndex: "change",
      key: "change",
      align: "right",
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      // loading={isloading}
      columns={columns}
      size="small"
      bordered
      pagination={false}
      rowKey={(record, idx) => idx}
      className="border-table custom-table user-tbl"
      scroll={{ x: 500, y: 250 }}
      // scroll={{ x: 500, y: 250 }}
      style={{ width: "100%" }}
    />
  );
};
